import _ from 'lodash'
import {CHANGE_CLIENT, LOGOUT} from './available';

export default {
  [CHANGE_CLIENT] (state, clientId) {
    state.currentClientId = clientId
    state.currentClient = _.get(state.availableClientsById, state.currentClientId, {})
  },
  [LOGOUT] () {

  }
}
